import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DadosEmpresaDetalharComponent } from './dados-empresa-detalhar.component';



@NgModule({
  imports: [RouterModule.forChild([
    { path: '', component: DadosEmpresaDetalharComponent }
  ])],
  exports: [RouterModule]
})
export class DadosEmpresaDetalharRoutingModule { }
